exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_widgets_3XQ9yTleOGZakfvoIfFlO {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_dlnyhkVIfsqLxB2sMKAw0 {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_2x2hBF4ToTUlbBY7jTNgaV {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_16lIor3-StX0zePqgM2Pnp {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_widgets": "IA_widgets_3XQ9yTleOGZakfvoIfFlO",
	"IA_filters": "IA_filters_dlnyhkVIfsqLxB2sMKAw0",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_2x2hBF4ToTUlbBY7jTNgaV",
	"IA_paginationPageCount": "IA_paginationPageCount_16lIor3-StX0zePqgM2Pnp"
};